import { HttpClient } from '@angular/common/http'
import { computed, inject, Injectable, signal } from '@angular/core'
import { ApiConfigService } from './api-config.service'
import { StateApp, UserAccount } from '@shared/models/appFlow'
import { BehaviorSubject, catchError, finalize, firstValueFrom, Observable, of, tap } from 'rxjs'
import { NavController } from '@ionic/angular'

import { GlobalStore } from 'src/app/store/global.store'
import { getRoutesByLevel } from 'src/app-levels/app-levels.index'

@Injectable({
  providedIn: 'root',
})
export class AppFlowService {
  private globalStore = inject(GlobalStore)
  private http = inject(HttpClient)
  private apiConfigService = inject(ApiConfigService)
  private navController = inject(NavController)

  private homeBase = 'solventa/home'

  public userLevel = computed(() => {
    return this.globalStore.appState.userLevel.level()
  })

  currentStatus: StateApp | undefined
  currentStatusSignal = signal<StateApp | undefined>(undefined)

  homeRefresher = new BehaviorSubject<number>(0)

  public updateRefresher(counterRefresh: number) {
    this.homeRefresher.next(counterRefresh)
  }

  public getStateApp(): Observable<StateApp> {
    return this.http.get<StateApp>(`${this.apiConfigService.API_STATE_APP}`).pipe(
      tap((resp: StateApp) => {
        this.currentStatus = resp
        this.currentStatusSignal.set(resp)

        /* GET USER ACCOUNTS */
        this.http
          .get<UserAccount[]>(`${this.apiConfigService.API_BASE}/auth/linked-accounts`)
          .pipe(
            catchError(() => of([])),
            tap(accounts => {
              this.globalStore.setAppState({ ...resp, accounts })
            }),
            finalize(() => {
              this.redirectByStatus(resp)
            }),
          )
          .subscribe()
        /* ----------------- */
      }),
    )
  }

  public async switchAccount(accountId: string) {
    firstValueFrom(
      this.http.post<StateApp>(`${this.apiConfigService.API_BASE}/auth/switch-account/${accountId}`, {}).pipe(
        tap(() => {
          this.getStateApp().subscribe()
          this.updateRefresher(this.homeRefresher.value + 1)
        }),
      ),
    )
  }

  private redirectByStatus(state: StateApp) {
    const routes = getRoutesByLevel(this.userLevel())
    const route = state.description as keyof typeof routes
    this.navController.navigateForward(routes[route], {
      animated: true,
      replaceUrl: true,
    })
  }

  public changeStatus() {
    return this.http.get(`${this.apiConfigService.API_BASE}/state/restart-cycle`)
  }
}
